import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { UrlUtil } from 'utility/UrlUtil'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '10px'
  },
  link: {
    'text-decoration': 'none'
  },
  contentHeader: {
    marginTop: '70px',
    marginBottom: '15px'
  },
  contentBody: {
    marginBottom: '50px'
  }
}))

export const GuestContent = (props) => {
  const classes = useStyles()
  const { searchParams } = props

  return (
    <Container className={classes.root}>
      <Typography
        variant='h1' align='center'
        className={classes.contentHeader}
      >お問い合わせありがとうございます
      </Typography>
      <Typography variant='body1' align='center' className={classes.contentBody}>
        お問い合わせを受け付けました。<br />
        企業担当者よりご連絡を差し上げますのでしばらくお待ちください<br /><br />
        ネタマッチでは様々なネタやイベントをご紹介しております。<br />
        会員の方にのみご紹介しているものも多数ございます。<br />
        これを機会に是非会員登録ください。<br />
      </Typography>
      <Typography variant='body1' align='center' className={classes.contentBody}>
        <Link className={classes.link} to={UrlUtil.SignUp(searchParams)}>
          会員登録はこちら
        </Link>
      </Typography>
    </Container>
  )
}
